import React from 'react';

/**
 * A component that helps with a few of the most common
 * use-cases throughout the codebase when rendering content:
 *
 * 1. renders an element with a custom tag name (useful when component tag names need to be dynamic)
 * 2. renders no element at all if the child content ever happens to be undefined
 * 3. renders potentially dangerous html strings
 * Taken from https://github.com/AudaxHealthInc/telemedicine-components/blob/main/src/Content/ParsedContent.tsx
 */
export const ParsedContent = (props: any = {}) => {
  const { children, tag, potentiallyDangerous } = props;
  if (!children) {
    return null;
  }
  if (!tag && !potentiallyDangerous) {
    return children;
  }
  const passedProps = { ...props };
  if (typeof children === 'string' && potentiallyDangerous) {
    passedProps.children = (
      // eslint-disable-next-line react/no-danger
      <div dangerouslySetInnerHTML={{ __html: children }} />
    );
  }
  const TagName = props.tag || 'div';
  delete passedProps.potentiallyDangerous;
  delete passedProps.tag;
  return <TagName {...passedProps} />;
};
